"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ErrorDialogActionsStyled = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _nikeDesignSystemComponents = require("@nike/nike-design-system-components");

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _templateObject;

var ErrorDialogActionsStyled = (0, _styled.default)(_nikeDesignSystemComponents.DialogActionsStyled)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  padding-top: 36px;\n\n  &:before {\n    content: none;\n  }\n"])));
exports.ErrorDialogActionsStyled = ErrorDialogActionsStyled;